module.exports = __webpack_public_path__ + "img/328.35be4132.png";